import { render, staticRenderFns } from "./room-actions.vue?vue&type=template&id=890eaec0"
import script from "./room-actions.vue?vue&type=script&lang=js"
export * from "./room-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports